module.exports = __webpack_public_path__ + "puxiimg4.png?089f70aca5fb4a7b69568f9bf588a097";